import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Message } from '../../../core/models/api.models';
@Component({ selector: 'app-user-message', standalone: true, imports: [DatePipe, TranslocoPipe], templateUrl: './user-message.html' })
export class UserMessage { @Input({ required: true }) message!: Message; @Output() copyRequested = new EventEmitter<string>(); }
